module.exports = "<div>\n    <div class=\"jumbotron\">\n        <h2>TrackerBase Reports Home</h2>\n        <p ng-if=\"reportsViewShell.userInfo.hasTrackerRights\">Welcome. Please select a report from the menu on the left.</p>\n        <p ng-if=\"!reportsViewShell.userInfo.hasTrackerRights\">You are not authorized to view any reports.</p>\n    </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-reports/ReportsMainPage.tpl.html
// module id = q85h
// module chunks = 1